export enum questionTypesEnum {
    Classic = 'classic',
    Photo = 'photo',
    GPT = 'gpt'

  }